import { FC } from 'react';
import { SpaceOptions } from '../../theme/UiThemeProvider'
import { Box } from '../Box'

export interface SpacerProps {
  direction?: 'vertical' | 'horizontal'
  size?: SpaceOptions | number
  hide?: boolean
}

export const Spacer: FC<SpacerProps> = ({ direction = 'vertical', size = 0, hide = false }) => {
  const height = direction === 'vertical' ? size : 0
  const width = direction !== 'vertical' ? size : 0
  if (hide) {
    return null
  } else {
    return <Box paddingTop={height} paddingLeft={width} />
  }
}
